import React from 'react'
import {Button, Label, Media} from 'reactstrap'
import {AvFeedback, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation'
import SFLogo from '../../images/sf-logo-horizontal.png'

let SetNewPasswordForm = ({onValidSubmit, onInvalidSubmit}) =>
    <AvForm onValidSubmit={onValidSubmit}
            onInvalidSubmit={onInvalidSubmit}
            className="col-md-6 col-sm-10 text-left">

        <div className="text-center">
            <Media object src={SFLogo} alt="SureFire Ag Logo" className="col-10 mb-4"/>
            <h2 className="mb-4">Set a New Password for Your Marksman Account</h2>
        </div>

        <AvGroup>
            <Label for="password">Password</Label>
            <AvInput name="password"
                     placeholder="********"
                     type="password"
                     validate={{minLength: {value: 8}}}
                     autoComplete="new-password"
                     required/>
            <AvFeedback>Please enter a password (at least 8 characters long.)</AvFeedback>
        </AvGroup>

        <AvGroup className="mb-4">
            <Label for="confirmPassword">Confirm Password</Label>
            <AvInput name="confirmPassword"
                     placeholder="********"
                     type="password"
                     validate={{match: {value: 'password'}}}
                     autoComplete="new-password"
                     required/>
            <AvFeedback>Passwords do not match</AvFeedback>
        </AvGroup>

        <AvGroup>
            <Button className="col-4 offset-8">Set Password</Button>
        </AvGroup>
    </AvForm>

export default SetNewPasswordForm



// WEBPACK FOOTER //
// ./src/components/ui/SetNewPasswordForm.js